<cm-page>
  <cm-page-tab label="Cluster Plan Details">
    <cluster-plan-details></cluster-plan-details>
  </cm-page-tab>
</cm-page>
